import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Root from './Root';
import reportWebVitals from './reportWebVitals';
import { initTheme } from './settings/theme';
import { initSettingsSecrets } from './settings/settingsSecrets';
import { registerServiceWorker } from './offline/registerServiceWorker';
import './i18n';

// Applied before first paint so there's no flash of the wrong theme.
initTheme();
// Starts watching the active project so encrypted settings (the AI keys) are
// decrypted on unlock and cleared on lock.
initSettingsSecrets();
registerServiceWorker();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log)) // trigger
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
